import React from 'react';
import { ExclamationTriangleIcon } from '@heroicons/react/24/outline';
import Modal from './Modal';

const ConfirmDialog = ({
  isOpen,
  onConfirm,
  onCancel,
  title = 'Are you sure?',
  message,
  confirmLabel = 'Confirm',
  cancelLabel = 'Cancel',
  isDangerous = false,
}) => (
  <Modal isOpen={isOpen} onClose={onCancel} size="sm" hideClose>
    <div className="flex gap-4">
      {isDangerous && (
        <div className="flex-shrink-0 flex items-center justify-center w-10 h-10 rounded-full bg-red-100">
          <ExclamationTriangleIcon className="h-5 w-5 text-red-600" />
        </div>
      )}
      <div className="flex-1 min-w-0">
        <h3 className="text-base font-semibold text-gray-900">{title}</h3>
        {message && <p className="mt-1 text-sm text-gray-600">{message}</p>}
      </div>
    </div>
    <div className="mt-5 flex justify-end gap-3">
      <button
        onClick={onCancel}
        className="px-4 py-2 text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded-lg hover:bg-gray-50 transition-colors"
      >
        {cancelLabel}
      </button>
      <button
        onClick={onConfirm}
        className={`px-4 py-2 text-sm font-medium text-white rounded-lg transition-colors ${
          isDangerous
            ? 'bg-red-600 hover:bg-red-700'
            : 'bg-primary-600 hover:bg-primary-700'
        }`}
      >
        {confirmLabel}
      </button>
    </div>
  </Modal>
);

export default ConfirmDialog;
